<!--
  - Copyright (c) 2022-2023. Haodong JU
  -->

<template>
  <v-container
    class="pa-2 pb-0 d-flex flex-column"
    style="height: 100%"
  >
    <div
      :class="$vuetify.breakpoint.lgAndUp ? 'py-4' : ''"
      class="d-flex align-center"
    >
      <back-button @close-event="$emit('close')" />
      <div>
        <div class="text-h3 font-weight-bold">
          {{ $t('editShowSort') }}
        </div>

        {{ $t('dragToSort') }}
      </div>
    </div>

    <div
      class="mt-4 flex-grow-1"
      style="overflow-y: scroll; max-height: 400px;"
    >
      <draggable
        v-model="realList"
        handle=".handle"
        style="display: grid;grid-template-columns: repeat(1,minmax(0,1fr));grid-gap: 4px"
      >
        <v-list-item
          v-for="a in realList"
          :key="a[itemId]"
        >
          <v-icon
            class="handle"
          >
            mdi-drag
          </v-icon>
          <v-list-item-title class="ma-lg-4">
            {{ a._langsname }}
          </v-list-item-title>
        </v-list-item>
      </draggable>
      <div
        class="d-flex align-center justify-center"
        style="position: absolute; bottom: 0; width: 100%; background: #fff; height: 50px"
      >
        <v-btn
          class="amber lighten-4 black--text"
          elevation="0"
          @click="save"
        >
          <v-icon
            left
            size="20"
          >
            mdi-content-save
          </v-icon>
          {{ $t('save') }}
        </v-btn>
      </div>
    </div>
  </v-container>
</template>

<script>
import draggable from 'vuedraggable'
import BackButton from '@/views/widget/uiComponent/BackButton.vue'

export default {
  name: 'SortFragment',
  components: {
    BackButton,
    draggable
  },
  props: {
    selectedAIdList: {},
    initialList: {
      type: Array
    },
    itemId: {
      default: 'id',
      type: String
    },
    itemSort: {
      default: 'sort',
      type: String
    }
  },
  data: function () {
    return {
      isShow: true,
      realList: []
    }
  },
  computed: {},
  watch: {
    initialList: {
      immediate: true,
      handler (val) {
        if (this.initialList?.length) {
          this.realList = this.initialList
        }
      }
    }
  },
  methods: {
    save () {
      this.$emit('save', this.realList)
    }
  }
}
</script>

<style scoped>

</style>
